export default {
  public_vapid_key: 'BJb3RsksEy71dTuvGSyH77VGYMjSXOpezre1w6zhC2fd7ptmfT5QsMjM8wUIdqIansoHqQYFrodahFyP-D9jo8k',
  config: {
    apiKey: 'AIzaSyATtvxechxNSSQX0l2aw9-rV471ZeCTUdg',
    authDomain: 'suitup-office.firebaseapp.com',
    databaseURL: 'https://suitup-office.firebaseio.com',
    projectId: 'suitup-office',
    storageBucket: 'suitup-office.appspot.com',
    messagingSenderId: '397686423382',
    appId: '1:397686423382:web:b9865f6db8a83179'
  }
}
